import React, { FunctionComponent } from 'react';
import Slider from 'react-slick';
import { useIsMobile } from '../../../hooks/useIsMobile';
import type { Props } from './types';

const mobileSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: true,
  centerMode: true,
  centerPadding: '10%',
  dots: true,
  draggable: true,
  swipe: true,
};

export const Presentation: FunctionComponent<Props> = ({ brands, noimage }) => {
  const isMobile = useIsMobile();

  const items = brands.map((brand, i) => (
    <div
      key={brand.brandId}
      className="sitetop-recruitment-container-link gtm-brand-view-count"
      data-event-name="brand on screen"
      data-category="topcontent"
      data-value={i < 6 ? `pick_up_brand${i + 1}` : 'pick_up_brand'}
      data-brandid={brand.brandId}
      data-companyid={brand.companyId}
    >
      <div className="sitetop-recruitment-container-box">
        <div className="sitetop-recruitment-container-box-inner">
          <a
            href={`/brands/${brand.brandId}`}
            data-event="click"
            data-category="topcontent"
            data-value={i < 6 ? `pick_up_brand${i + 1}` : 'pick_up_brand'}
          >
            {brand.image ? (
              <div
                style={{
                  background: `url(${brand.image}) no-repeat center center`,
                  backgroundSize: 'cover',
                }}
                className="sitetop-recruitment-container-box-inner-img-bg"
              />
            ) : (
              <img
                src={noimage}
                alt={brand.altText}
                className="sitetop-recruitment-container-box-img"
              />
            )}
          </a>
          <div className="sitetop-recruitment-container-box-inner-mag">
            <a
              href={`/brands/${brand.brandId}`}
              data-event="click"
              data-category="topcontent"
              data-value={i < 6 ? `pick_up_brand${i + 1}` : 'pick_up_brand'}
            >
              <div className="sitetop-recruitment-container-box-title">
                {brand.displayName}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <section className="sitetop-recruitment" id="pick_up_brand">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          PICK UP BRAND
          <span className="sitetop-pickup-sub">注目のブランド</span>
        </h2>
        <a
          href="/brands"
          className="sitetop-pickup-companies gtm-button-view-count"
          data-event-name="button on screen"
          data-event="click"
          data-category="topcontent"
          data-value="brand_to_all"
        >
          ブランド一覧へ
        </a>
      </div>
      <div className="sitetop-recruitment-container">
        {isMobile ? (
          <Slider {...mobileSettings} className="sitetop-recruitment-container-inner">
            {items}
          </Slider>
        ) : (
          items
        )}
      </div>
      <a
        href="/brands"
        className="sitetop-pickup-spcompanies gtm-button-view-count"
        data-event="click"
        data-category="topcontent"
        data-value="brand_to_all"
      >
        ブランド一覧へ
      </a>
    </section>
  );
};
